import React from 'react'
import ReactDOM from 'react-dom'

class RichText extends React.Component {

    componentDidMount() {
        this.props.onLoaded(ReactDOM.findDOMNode(this.refs.editorContainer))
    }

    shouldComponentUpdate() {
        return false
    }

    render() {
        return (
            <div className="rich-text-content">
                <div ref="editorContainer"/>
            </div>
        )
    }
}

RichText.propTypes = {
    onLoaded: React.PropTypes.func.isRequired
}

module.exports = RichText



// WEBPACK FOOTER //
// ./src/components/richtext.jsx